import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './circle-icon.module.css'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dark: PropTypes.bool,
    style: PropTypes.shape({
        backgroundColor: PropTypes.string
    })
}

/**
 * Renders a provided icon into a circle, expects an SVG or a React Component that renders an SVG.
 *
 * @todo [WFICON-57] Move CircleIcon to a suitable widget library and rename
 *
 * @see {@link https://confluence.ttt-sp.com/display/TTB/Molecules#Molecules-Rows}
 *
 * @example
 * <CircleIcon><SettingsIcon /></CircleIcon>
 *
 * @param {Object} props - The current component props
 * @param {ReactElement} [props.children] - Should be an SVG or a React Component that renders an SVG
 * @param {string} [props.className] - A CSS class to append to the component
 * @param {boolean} [props.dark] - Shall we render a darker version instead?
 * @param {Object} [props.style] - A CSS inline style object to append to the component
 * @returns {ReactElement}
 */
function CircleIcon(props) {
    const { children, className, dark, style } = props

    const divProps = {
        className: cx(styles['circle'], { [styles['dark']]: dark }, className)
    }

    if (style) {
        divProps.style = style
    }

    return <div {...divProps}>{children}</div>
}

CircleIcon.propTypes = propTypes

export { CircleIcon }
